module.exports = __webpack_public_path__ + "img/1080_16.523ac8d9.jpg";